import { createFileRoute } from '@tanstack/react-router';

import { ArtistWorkRequestInfoPage } from '@/features/work/pages/artist-work-request-info-page/ArtistWorkRequestInfoPage';
import { redirectUnauthenticated } from '@/shared/helper/redirectUnauthenticated';

export const Route = createFileRoute('/artist/$id/work-request/$workRequestId')(
  {
    beforeLoad: ({ context }) => {
      redirectUnauthenticated(context);
    },
    component: ArtistWorkRequestInfoPage
  }
);
